module.exports = __webpack_public_path__ + "img/360.bb170685.png";